import {mcToast,sendLog,share,checkEmpty,checkPhone,random,checkInt} from "../../../util/util"
import Swiper from 'swiper';
import loading from '../../../components/loading/index.vue'
var imgSwiper;
export default {
    data() {
        return {
            flagStr:'',//判断是锁号还是账号的字符串
            shareStr:'',
            vipType:'',
            globalId:"",
            lockCode:"",
            flag:1,//1是账号 2是锁号 默认是1
            accountName:"",//用户名
            accountTips:"",//切换账号提示语
            yuyueFixed:false,//点击预约是否弹框 主要是判断权限
            changeBtn:["1","2"],//1 登录其他账号  2锁号登录 3登录其他锁号 4账号登录 5 账号切换锁号确认  6锁号切换账号确认
            barWidth:0,//进度条的进度

            showRule:false,//是否显示锦囊弹框
            showNoLogin:true,//是否显示登陆
            showChangeAccount:false,//切换账号
            showShare:false,//分享弹窗
            showLoading:false,

            infoData:{},//返回的信息
            memberDayList:[],//会员日进行中的数据  每次需要改 数字
            historyList:[],//历史获奖记录
            prizeInfo:{},//礼品信息
            giftNameArr:[{accountName:'北京地区39'},{accountName:'陕西地区62'},{accountName:'山东地区05'},
            {accountName:'江苏地区32'},{accountName:'浙江地区67'},{accountName:'山西地区96'},{accountName:'广东地区52'},
            {accountName:'四川地区76'},{accountName:'新疆地区29'},{accountName:'上海地区88'},{accountName:'西藏地区13'},],//中奖名单       
        }
    },
    components: {
        loading
    },
    created() {
        if (!this.$route.params.flagStr) {
            this.$router.push({
                path: '/memberDay/memberDayIndex',
                name: 'memberDayIndex',
            })
        }else{
            this.flagStr=this.$route.params.flagStr
            this.shareStr=this.$route.params.shareStr
            this.vipType=this.$route.params.vipType
        }
        sendLog("1447");
        this.queryInfo(0);
        share('和我一起来广材，建造你的理想国',
            '广材会员登录即刻参与',
            'http://gcj-pub.oss-cn-beijing.aliyuncs.com/wechat/images/unday-shared.png',
            'http://buy.gldjc.com/memberDay/memberDayIndex?'+this.flagStr)
    },
    mounted() {
        localStorage.setItem("backUrl",window.location.href)
        new Swiper ('.win-list-container', {
            autoplay: {
                delay: 500,//1秒切换一次
                disableOnInteraction: false,  
            },
            direction : 'vertical',
            speed:1000,
            slidesPerView : 1,
            centeredSlides : true,
            loop : true,
            height:30,
            autoplayDisableOnInteraction : false,
            observer:true,
        });

         
    },
    methods: {
        // 查询信息
        queryInfo(num){
            //0是初始话 1是账号 2是锁号
            if (num==0) {
                var str="flag="
            }else{
                var str="flag="+num;
                this.flag=num;
            }
            this.showLoading=true;
            
            axios.post('/member/party/inactive?'+this.flagStr).then(res => {
                this.showLoading=false;
                // 判断有没有登陆
                if (res.data.code==4035) {
                    this.showNoLogin=true;
                    return;
                }else{
                    this.showNoLogin=false;
                }
                this.globalId=res.data.data.globalId;
                this.lockCode=res.data.data.lockInfo?res.data.data.lockInfo.lockCode:"";
                this.infoData=res.data.data;

                // 会员日数据
                this.memberDayList=res.data.data.memberDayList;   
                this.historyList=res.data.data.myLotteryPrizes;
                this.prizeInfo=res.data.data.reserveHdPrizeInfo;         
                
                this.showChangeAccount=false;
                this.handleAccount();
                this.$nextTick(argument => {
                    this.handleBar();
                })
                
            });
        },
        //点击未登录
        login(){
            this.$router.push({
                path: '/login/loginIndex',
                name: 'loginIndex',
                params:{
                    page:"1",
                }
            })
        },
        //点击未登录
        changeAccount(){
            this.$router.push({
                path: '/login/loginIndex',
                name: 'loginIndex',
            })
        }, 
        // 点击规则
        clickRule(){
            sendLog("1459");
            this.showRule=true;
        },

        //处理进度条
        handleBar(){
            if (this.infoData.score<10) {
                this.barWidth=this.infoData.score*3;
            }else if (this.infoData.score>9 && this.infoData.score<100) {
                this.barWidth=20+this.infoData.score;
            }else if (this.infoData.score>99 && this.infoData.score<1000) {
                this.barWidth=120+this.infoData.score/25;
            }else if (this.infoData.score>999 && this.infoData.score<10000) {
                this.barWidth=160+this.infoData.score/500;
            }else {
                this.barWidth=200;
            }
        },
        // 处理切换账号
        handleAccount(){
            this.yuyueFixed=false;
            // 都没有绑定
            if (this.showNoLogin) {
                return
            }
            // 绑定账号 没有绑定锁号
            if (this.infoData.isAccountBind && !this.infoData.isLockBind) {
                if (this.infoData.vipType) {
                    this.accountTips="您未绑定锁号,请选择";
                }else{
                    this.accountTips="您当前绑定的账号无广材网会员权限,请选择"
                    this.yuyueFixed=true;
                }    
                this.changeBtn=["1","2"];
            }
            // 只绑定锁号 未绑定账号
            if (!this.infoData.isAccountBind && this.infoData.isLockBind) {
                
                if (this.infoData.lockInfo.hasLockInterest) {
                    this.accountTips="您未绑定广材网账号,请选择"
                }else{
                    this.accountTips="您当前绑定的锁号无数据包会员权限,请选择"
                    this.yuyueFixed=true;
                }    
                this.changeBtn=["3","4"];
            }
            // 同时绑定
            if (this.infoData.isAccountBind && this.infoData.isLockBind) {
                
                if (!this.infoData.vipType && this.infoData.lockInfo.hasLockInterest) {
                    this.accountTips="您当前绑定的账号无广材网会员权限,请选择";
                    this.changeBtn=["1","3"];
                }else if (!this.infoData.vipType && !this.infoData.lockInfo.hasLockInterest) {
                    this.accountTips="您当前绑定的账号无广材网会员权限,请选择";
                    this.changeBtn=["1","2"];
                    this.yuyueFixed=true;
                }else if (this.infoData.vipType && !this.infoData.lockInfo.hasLockInterest){
                    this.accountTips="您当前绑定的锁号无数据包会员权限,请选择";
                    this.changeBtn=["3","1"];
                }else{
                    if (this.flag==1) {
                        this.accountTips="是否选择切换锁号登录";
                        this.changeBtn=["1","5"];
                    }else{
                        this.accountTips="是否选择切换账号登录";
                        this.changeBtn=["3","6"];
                    }
                }
            }
        },
        //解绑账号
        untyingAccount(){
            axios.post('/bindAccount/unbind/static/confirm').then(res => {
               if (res.data.code==200) {
                    this.showAccountFixed=false; 
                    this.$router.push({
                        path: '/login/loginIndex',
                        name: 'loginIndex',
                        params:{
                            type:'account',
                            page:"1",
                        }
                    })    
               }
            })
        },
        //解绑锁号
        untyingLock(){
            axios.post('/bindLock/unbind/static/confirm').then(res => {
               if (res.data.code==200) {
                    this.showLockFixed=false; 
                    this.$router.push({
                        path: '/login/loginIndex',
                        name: 'loginIndex',
                        params:{
                            type:'lock',
                            page:"1",
                        }
                    })    
               }
            })
        },
        // 预约
        clickOrder(){
            sendLog("1468");
            if (!this.vipType) {
                mcToast('您无广材网会员权限');
                return
            }
            if (!this.infoData.isHdReserve) {
                // 如果是通过分享进来的
                if (this.shareStr.split('globalId=')[1]) {
                    this.addScore({flagStr:'globalId='+this.shareStr.split('globalId=')[1],source:2})
                }
                 if (this.shareStr.split('lockCode=')[1]) {
                    this.addScore({flagStr:'lockCode='+this.shareStr.split('lockCode=')[1],source:2})
                }
            }
            this.$axios.get("/hd/reserveHd?"+this.flagStr).then(res=>{
                mcToast('您已预约成功，请查看大数据公众号最新微信消息，下载全国人工价合集',4000);
                this.infoData.isHdReserve=true;
            })
                            
        },
        // 点击分享
        clickShare(){
            this.showShare=true
            let url='http://buy.gldjc.com/memberDay/memberDayIndex?'+this.flagStr
            share('和我一起来广材，建造你的理想国',
            '广材会员登录即刻参与',
            'http://gcj-pub.oss-cn-beijing.aliyuncs.com/wechat/images/unday-shared.png',
            url)
            sendLog("1458");
        },
        // 加积分 积分来源source：1，活动任务 2：分享
        addScore(obj){
            this.$axios.get("/score/add?"+obj.flagStr+"&source="+obj.source).then(res=>{
                if (res && res.data && res.data.code==200) {
                    
                }
            })
        }, 
    }
}